// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-wrapper li label {
  width: 145px;
}

.yellow {
  color: hsl(48, 100%, 67%);
}

.green {
  color: hsl(141, 71%, 48%);
}

.gray {
  color: hsl(0, 0%, 96%);
}

.timeline {
  position: relative;
}

.timeline:before {
  content: " ";
  top: 0px;
  left: 15px;
  bottom: 0px;
  width: 4px;
  background: #ddd;
  position: absolute;
}

.timeline li {
  padding-left: 30px;
  position: relative;
  border-bottom: none;
}

.timeline li span {
  position: absolute;
  width: 16px;
  height: 16px;
  border: 3px solid salmon;
  background-color: #fff;
  border-radius: 100%;
  left: 9px;
  top: 15px;
  z-index: 99;
}

.timeline li:hover {
  background: transparent !important;
}

:host ::ng-deep empty-uname .empty-img {
  width: 40px !important;
  height: 40px;
  font-size: 19px;
}

@media screen and (min-width: 769px) {
  .column.is-one-quarter, .column.is-one-quarter-tablet {
    flex: none;
    width: 19%;
  }
}
.list-wrapper .list-collapse {
  padding: 15px 10px 10px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.list-wrapper .list-collapse span i {
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/notification/real-update/real-update.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,YAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;AACJ;;AAEA;EACI,kCAAA;AACJ;;AAIK;EACG,sBAAA;EACA,YAAA;EACA,eAAA;AADR;;AAMA;EACI;IAEI,UAAA;IACA,UAAA;EAHN;AACF;AAKA;EACI,4BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAHJ;;AAKA;EACI,eAAA;AAFJ","sourcesContent":[".list-wrapper li label {\n    width: 145px;\n}\n\n.yellow {\n    color: hsl(48, 100%, 67%);\n}\n\n.green {\n    color: hsl(141, 71%, 48%);\n}\n\n.gray {\n    color: hsl(0, 0%, 96%);\n}\n\n.timeline {\n    position: relative;\n}\n\n.timeline:before {\n    content: ' ';\n    top: 0px;\n    left: 15px;\n    bottom: 0px;\n    width: 4px;\n    background: #ddd;\n    position: absolute;\n}\n\n.timeline li {\n    padding-left: 30px;\n    position: relative;\n    border-bottom: none;\n}\n\n.timeline li span {\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    border: 3px solid salmon;\n    background-color: #fff;\n    border-radius: 100%;\n    left: 9px;\n    top:15px;\n    z-index: 99;\n}\n\n.timeline li:hover {\n    background: transparent !important;\n}\n\n\n:host ::ng-deep empty-uname {\n     .empty-img{\n        width: 40px !important;\n        height: 40px;\n        font-size: 19px;\n     }\n}\n\n\n@media screen and (min-width: 769px) {\n    .column.is-one-quarter, .column.is-one-quarter-tablet {\n        -ms-flex: none;\n        flex: none;\n        width: 19%;\n    }\n}\n.list-wrapper .list-collapse {\n    padding: 15px 10px 10px 10px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.list-wrapper .list-collapse span i{\n    font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
